import styled from 'styled-components';

import { body } from '@constants/fonts';

export const ValuesWrapper = styled.div`
  width: 90%;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  ${(props) => props.theme.breakpoints.down('sm')} {
    height: 100px;
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: 0px;
  }
`;

export const ValueH2Wrapper = styled.span`
  width: 80%;
  text-align: center;

  ${(props) => props.theme.breakpoints.down('sm')} {
    text-align: left;
  }
`;

export const ValueH2 = styled.span<{ textSize: number }>`
  font-size: ${(props) => props.textSize || 64}px;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-family: ${body};

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 52px;
  }
`;

export const DateH2 = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  opacity: 0.7;
`;

export const LocationDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;

export const FirstCircle = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.main};
  min-width: 308px;
  max-width: 308px;
  min-height: 308px;
  max-height: 308px;
  border-radius: 50%;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 0 0 6px 0 ${({ theme }) => theme.palette.grey['900']}24;

  ${(props) => props.theme.breakpoints.down('sm')} {
    min-width: 100%;
    min-height: auto;
    background-color: transparent;
    box-shadow: none;
  }
`;

export const SecondCircle = styled.div`
  background-color: ${({ theme }) => theme.palette.common.accentLightblue};
  opacity: 0.05;
  position: absolute;
  min-width: 800px;
  min-height: 800px;
  border-radius: 50%;
  z-index: -10;
  overflow: hidden;

  ${(props) => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const ThirdCircle = styled.div`
  position: absolute;
  border-radius: 50%;
  overflow: hidden;
  z-index: -15;
  opacity: 0.9;
  background: linear-gradient(
    144.21deg,
    ${({ theme }) => theme.palette.gradient.light} 0%,
    ${({ theme }) => theme.palette.gradient.dark} 100%
  );
  box-shadow: 0 0 20px 0 ${({ theme }) => theme.palette.grey['900']}24;

  ${(props) => props.theme.breakpoints.up('lg')} {
    min-width: 220vh;
    min-height: 220vh;
  }

  ${(props) => props.theme.breakpoints.between('md', 'lg')} {
    position: fixed;
    min-width: 220vh;
    min-height: 220vh;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    position: fixed;
    min-width: 200vh;
    min-height: 200vh;
    margin-left: -50%;
  }
`;

export const Subtext = styled.span`
  font-size: 30px;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  text-align: bottom;
  font-weight: lighter;
  display: inline;
  font-family: ${body};

  ${(props) => props.theme.breakpoints.down('sm')} {
    font-size: 20px;
  }
`;
